import {
  FaGlobe,
  FaInstagram,
  FaYoutube,
  FaFacebook,
  FaTwitter,
} from 'react-icons/fa';


// Popular categories (alphabetically sorted)
export const popularCategories = [
    'Automotive',
    'Beauty & Personal Care',
    'Business & Startups',
    'Education & Career',
    'Entertainment',
    'Fashion & Style',
    'Finance & Investing',
    'Fitness',
    'Food',
    'Gaming & Anime',
    'Health',
    'Home & Decor',
    'Law, Rights & Activism',
    'Learning',
    'Lifestyle & Living',
    'News & Current Affairs',
    'News, Media & Magazines',
    'Pets & Animals',
    'Politics',
    'Science & Technology',
    'Sports',
    'Tech',
    'Travel & Places',
  ];
  
  
export const allCategories = [
    'Acting, Professional: Movies',
    'Acting, Professional: TV, OTT',
    'All Other Motoring: Trucks Etc.',
    'Animal Love & Welfare',
    'Anime (Reviews / Quotes Etc)',
    'Art, Design & Crafts',
    'Automotive (Cars / Bikes Etc)',
    'Automotive News',
    'Backpacking & Biking',
    'Beauty & Personal Care: Makeup',
    'Bike Enthusiast: Bike & Products',
    'Body, Body-care & Vitalities',
    'Breaking News',
    'Business & Finance',
    'Business & Startups',
    'Career & Job Growth',
    'City-focused: Hotspots & Life',
    'Comedy & Memes',
    'Community Pages',
    'Console & Game Reviews',
    'Cooking, Recipes & Baking',
    'Cosplay-ing',
    'Crafts & DIY Arts',
    'Creative Learning',
    'Creative Writing & Story-Telling',
    'Culture & History',
    'DIY & Crafts',
    'Documentaries',
    'Doodling & Animation',
    'Education',
    'Entertainment',
    'Entertainment Dance Videos',
    'ESports & Pro-Gaming',
    'ESports / Professional Gaming',
    'Events & Fests',
    'Family / Couple Vlogs',
    'Family, Kids & Pets',
    'Fan-Page: Sports & Sports Celebs',
    'Fan-Page: Sports Buzz',
    'Fan-Pages: Movie Buffs',
    'Farming / Ecology',
    'Fashion',
    'Feel-Good News / Stroies',
    'Feel-Good Stories',
    'Film-making & Cinematography',
    'Finance & Investments',
    'Fitness',
    'Food',
    'Food & Foodies Community',
    'Food Reviews',
    'Founders & Startups',
    'Freelance: Tips & Hacks',
    'Fun Shorts: Pranks & Roasts',
    'Fun-Content (Skins / Drama)',
    'Gadget Reviews & Unboxing',
    'Gaming & Anime',
    'Gaming & Anime Community',
    'Gardening & Landscaping',
    'Hair-Care & Hair-Styling',
    'Health',
    'Home & Decor',
    'Human Rights & Social Justice',
    'Info, Science, Biz & Podcast',
    'Interior Styling & Decor',
    'Investing Guides',
    'Kids-Fashion',
    'Law, Rights & Activism',
    'Learning',
    'Legal Education',
    'LGBTQ Community',
    'LGBTQ Rights',
    'Lifestyle & Culture',
    'Lifestyle & Living',
    'Makeup & Cosmetics',
    'Marketing & Branding',
    'Mental Wellness / Self-Care',
    'Mobile Gaming',
    'Motor Sports & Racing',
    'Movies & Music',
    'Political News',
    'Political News & Analysis',
    'Political Satire & Humor',
    'Politics',
    'Politics & Civil Rights',
    'Products Reviews',
    'Professional Dancing',
    'Professional Singing & Musicians',
    'Professional: Individual Sports',
    'Professional: Team Sports',
    'Professional/Career Focused',
    'Programming, Coding & AI',
    'Real-Estate / Homes',
    'Relationships & Dating',
    'Religion & Spiritual',
    'Re-modeling & Home-Fixes',
    'Rights & Equality',
    'School/College Curriculum',
    'Sexual Wellness / Intimacy',
    'Singing & Music Videos',
    'Sketching & Painting',
    'Skin-Care',
    'Small-Biz: Tips & Hacks',
    'Softwaren& App: Tips, Hacks & Reviews',
    'Sports',
    'Sports News',
    'Sports News & Coverage',
    'Standup Professional',
    'Streaming Games',
    'Street / People',
    'Street / People Photography',
    'Style & Grooming: Looks & Wear',
    'Sustainable Fashion',
    'Sustainable Living',
    'Tech',
    'Tech & Innovations',
    'Tech News & Updates',
    'Test-Prep',
    'Toys / Product Reviews',
    'Training & Fitness',
    'Travel & Food',
    'Travel & Food Photography',
    'Travel & Places',
    'UI / UX Design: Tips & Hacks',
    'Vegan Food',
    'Viral & Memes (Pages)',
    'Visual Editing Tips',
    'Vox-Pop / Street-Polls & QnA',
    'Web Development',
    'Wellness & Yoga',
    'Weddings',
    'Wildlife Conservation',
    'Wildlife Photography',
    'Women Community',
    'Women Empowerment',
    'Women Entrepreneurship',
    'Women Wellness / Pregnancy',
    'Writing & Blogging',
    'YouTube Creators',
    'Yoga & Meditation',
    'Youth Motivation',
    'Zoology & Animal Science',
  ];  

  // Popular cities in India
export  const popularCities = [
    'Bengaluru', 'Chennai', 'Delhi', 'Gurgaon', 'Hyderabad',
    'Kolkata', 'Mumbai', 'Navi Mumbai', 'Pune'
  ];

  // All cities in India (extended list)
export const allCities = [
    'Agra', 'Ahmedabad', 'Ajmer', 'Allahabad', 'Amritsar', 'Aurangabad',
    'Bengaluru', 'Bhopal', 'Bhubaneswar', 'Chandigarh', 'Chennai', 'Coimbatore',
    'Delhi', 'Faridabad', 'Ghaziabad', 'Goa', 'Gurgaon', 'Guwahati',
    'Hyderabad', 'Indore', 'Jaipur', 'Jalandhar', 'Jammu', 'Kanpur',
    'Kochi', 'Kolkata', 'Lucknow', 'Ludhiana', 'Madurai', 'Mangalore',
    'Mumbai', 'Mysore', 'Nagpur', 'Nashik', 'Navi Mumbai', 'Noida',
    'Patna', 'Pune', 'Raipur', 'Rajkot', 'Ranchi', 'Surat',
    'Thane', 'Thiruvananthapuram', 'Vadodara', 'Varanasi', 'Vijayawada', 'Visakhapatnam'
  ];

    // Popular languages
export const popularLanguages = ['English', 'Hindi', 'Tamil', 'Telugu', 'Marathi', 'Bengali', 'Gujarati', 'Kannada', 'Malayalam'];

    // All languages
export const allLanguages = [
      'Assamese', 'Bengali', 'Bodo', 'Dogri', 'English', 'Gujarati',
      'Hindi', 'Kannada', 'Kashmiri', 'Konkani', 'Maithili', 'Malayalam',
      'Manipuri', 'Marathi', 'Nepali', 'Odia', 'Punjabi', 'Sanskrit',
      'Santali', 'Sindhi', 'Tamil', 'Telugu', 'Urdu', 'Spanish', 'French', 'German'
    ];
  
    // Follower ranges with platform-specific data
export const followerRanges = [
      { name: 'Nano', instagram: '1k - 10k', youtube: '1k - 5k' },
      { name: 'Micro', instagram: '10k - 50k', youtube: '5k - 20k' },
      { name: 'Macro', instagram: '50k - 500k', youtube: '20k - 100k' },
      { name: 'Mega', instagram: '500k - 1M', youtube: '100k - 1M' },
      { name: 'Celeb', instagram: '1M+', youtube: '1M+' },
    ];
  
export const platformOptions = [
      { name: 'Instagram', icon: <FaInstagram className="text-pink-600 text-xl" /> },
      { name: 'YouTube', icon: <FaYoutube className="text-red-600 text-xl" /> },
      { name: 'Facebook', icon: <FaFacebook className="text-blue-600 text-xl" /> },
      { name: 'Twitter', icon: <FaTwitter className="text-blue-600 text-xl" /> },
      { name: 'All', icon: <FaGlobe className="text-purple-600 text-xl" /> },
    ];

export const contentTypes = [
      "Fashion",
      "Health And Fitness",
      "Sports",
      "Entertainment",
      "Musician",
      "Photography",
      "Home Decor",
      "Technology",
      "Travel",
      "Vlogger",
      "Beauty And Personal Care",
      "Gaming",
      "Education"
    ];